import { InitialActionAllower } from '@creditsights/styleguide-web/components/DataView';
import { MouseEvent } from 'react';
import { DataViewConfig } from '@creditsights/styleguide-web';
import { ROUTES } from '../../../Base.constants';
import {
  CompaniesFormatter,
  DateRenderer,
  TitleFormatter,
  IncludedContentFormatter,
  GhostLinkRenderer,
} from '../../../components/formatters';
import { ArticleIncludedContent } from '../../../models';
import { ContentTypeRenderer } from '../../../components/formatters/ContentTypeRenderer';

// const INCLUDED_CONTENT_COMPANY_COUNT = 3;

export const viewConfig = (
  onArticleClick?: (article: ArticleIncludedContent, event: MouseEvent<HTMLElement>) => void,
  isPreviewable?: boolean
): DataViewConfig<ArticleIncludedContent> => {
  const shouldAllowInitialAction: InitialActionAllower = (row) => isPreviewable || !!row?.isDisabled;
  const routeToCallback = (articleId) => ROUTES.article(articleId);

  return {
    expandedViewConfig: {
      title: {
        dataKey: 'content.title',
        dataRenderer: TitleFormatter,
        dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
      },
      subtitle: [
        {
          renderWithoutDataValue: true,
          dataRenderer: GhostLinkRenderer,
          dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
        },
        {
          dataKey: 'articleType',
          dataRenderer: ContentTypeRenderer,
          dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
        },
        {
          dataKey: 'publishDate',
          dataRenderer: DateRenderer,
          dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
        },
        {
          dataKey: 'companies',
          // TODO: Switch to TickersFormatter when Ticker data is fixed
          // dataRenderer: TickersFormatter({ companyCount: INCLUDED_CONTENT_COMPANY_COUNT }),
          dataRenderer: CompaniesFormatter(),
          dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
        },
      ],
      content: {
        dataKey: 'content.summary',
        dataRenderer: IncludedContentFormatter,
        dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
      },
    },
    onRowMouseUp: onArticleClick,
  };
};

export const printViewConfig: DataViewConfig<ArticleIncludedContent> = {
  expandedViewConfig: {
    title: {
      dataKey: 'content.title',
      dataRenderer: TitleFormatter,
    },
    content: {
      dataKey: 'content.summary',
    },
  },
};

export const getKey = (article: ArticleIncludedContent): number => article.id;
